export class WCServices {
    // [1, 23, 37, 14]
    constructor() {
        this.intervalStore = null;
        this.storeLoad = false;
        this.products = {};
        this.intervalStore = setInterval(() => {
            if (window['webComponentsStore']?.productsRouting?.manager) {
                clearInterval(this.intervalStore);
                this.storeLoad = true;
                this.products = {
                    50: {
                        id: 50,
                        name: 'public-cloud',
                        label: 'Public cloud',
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/ng/public-cloud/all`,
                            admin3: null,
                            faq: null,
                            hosting: null,
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order2/`,
                        },
                        icon: {
                            color: '#275F86',
                            filter: 'invert(55%) sepia(89%) saturate(381%) hue-rotate(127deg) brightness(92%) contrast(92%)',
                        },
                    },
                    1: {
                        id: 1,
                        name: 'hosting-web',
                        label: window['webComponentsStore']?.translate('Hebergement Web'),
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/hosting-web/all`,
                            admin3: 'root.products.hosting-web.list',
                            faq: 'https://www.infomaniak.com/fr/support/faq/admin2/hebergement-web',
                            hosting: 'https://www.infomaniak.com/gtl/hosting.web-and-mail.web',
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order2/domain?hosting_order=true`,
                        },
                        icon: {
                            color: '#1dbab0',
                            filter: 'invert(55%) sepia(89%) saturate(381%) hue-rotate(127deg) brightness(92%) contrast(92%)',
                        },
                    },
                    14: {
                        id: 14,
                        name: 'domain',
                        label: window['webComponentsStore']?.translate('Domaine'),
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/domain/all`,
                            admin3: 'root.products.domain.list',
                            faq: 'https://www.infomaniak.com/fr/support/faq/admin2/domaine',
                            hosting: 'https://www.infomaniak.com/gtl/domains',
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order2/domain`,
                        },
                        icon: {
                            color: '#7986CB',
                            filter: 'invert(52%) sepia(27%) saturate(725%) hue-rotate(193deg) brightness(97%) contrast(88%)',
                        },
                    },
                    23: {
                        id: 23,
                        name: 'hosting-mail',
                        label: window['webComponentsStore']?.translate('Service Mail'),
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/ng/hosting-mail/all`,
                            admin3: 'root.products.hosting-mail.list',
                            faq: 'https://www.infomaniak.com/fr/support/faq/admin2/hebergement-mail',
                            hosting: 'https://www.infomaniak.com/gtl/hosting.web-and-mail.mail',
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order2/domain?mail_order=true`,
                        },
                        icon: {
                            color: '#D81B60',
                            filter: 'invert(18%) sepia(81%) saturate(3289%) hue-rotate(323deg) brightness(91%) contrast(95%)',
                        },
                    },
                    37: {
                        id: 37,
                        name: 'swiss-backup',
                        label: window['webComponentsStore']?.translate('Swiss Backup'),
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/swiss-backup/all`,
                            admin3: 'root.products.swiss-backup.list',
                            faq: 'https://www.infomaniak.com/fr/support/faq/admin2/swiss-backup',
                            hosting: 'https://www.infomaniak.com/swiss-backup',
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order/swiss_backup`,
                        },
                        icon: {
                            color: '#3b4e66',
                            filter: 'invert(27%) sepia(16%) saturate(993%) hue-rotate(174deg) brightness(98%) contrast(91%)',
                        },
                    },
                    // 23: {
                    //     label: wcShared.translate("Hebergement Mail"),
                    //     alias: "hosting-mail",
                    //     state: "root.products.hosting-mail.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/hosting-mail/all`,
                    // },
                    // 3: {
                    //     label: wcShared.translate("Streaming audio"),
                    //     alias: "radio",
                    //     state: "root.products.radio.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/radio/all`,
                    // },
                    // 4: {
                    //     label: wcShared.translate("Streaming video"),
                    //     alias: "video",
                    //     state: "root.products.video.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/video/all`,
                    // },
                    // 6: {
                    //     label: wcShared.translate("Billeterie"),
                    //     alias: "tickets",
                    //     state: "root.products.tickets.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/tickets/all`,
                    // },
                    // 7: {
                    //     label: "VOD/AOD",
                    //     alias: "vod",
                    //     state: "root.products.vod.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/vod/all`,
                    // },
                    // 10: {
                    //     label: "Housing",
                    //     alias: "housing",
                    //     state: "root.products.housing.item.dashboard",
                    //     stateParams: {
                    //         id: idHousing,
                    //     },
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/housing/${idHousing}/all`,
                    // },
                    // 25: {
                    //     label: wcShared.translate("Serveur Cloud"),
                    //     alias: "cloud",
                    //     state: "root.products.cloud.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/cloud/all`,
                    // },
                    // 26: {
                    //     label: wcShared.translate("NAS Synology"),
                    //     alias: "nas",
                    //     state: "root.products.nas.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/nas/all`,
                    // },
                    // 28: {
                    //     label: wcShared.translate("Accreditation"),
                    //     alias: "accreditation",
                    //     state: "root.products.accreditation.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/accreditation/all`,
                    // },
                    // 29: {
                    //     label: "Newsletter",
                    //     alias: "newsletter",
                    //     state: null,
                    //     url: wcShared?.store?.productsRouting?.newsletter,
                    // },
                    // 30: {
                    //     label: wcShared.translate("Hebergement Tres Haute Disponibilite"),
                    //     alias: "cloud-hd",
                    //     state: null,
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/cloud-hd/all`,
                    // },
                    // 31: {
                    //     label: wcShared.translate("Gestionnaire d'invites"),
                    //     alias: "invitation",
                    //     state: "root.products.invitation.list",
                    //     stateParams: {
                    //         groupId: this.current_group?.id
                    //     },
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/invitation/landing`,
                    // },
                    // 34: {
                    //     label: wcShared.translate("Certificat SSL"),
                    //     alias: "certificate",
                    //     state: "root.products.certificate.list",
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/certificate/all`,
                    // },
                    // 35: {
                    //     label: "Jelastic Cloud",
                    //     alias: "jelastic",
                    //     state: "root.products.jelastic.item.dashboard",
                    //     stateParams: {
                    //         groupId: this.current_group?.id,
                    //         id: idJelastic,
                    //     },
                    //     url: `${wcShared?.store?.productsRouting?.manager}/v3/jelastic/${idJelastic}/dashboard`,
                    // },
                    40: {
                        id: 40,
                        name: 'drive',
                        label: 'kDrive',
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/ng/drive/all`,
                            admin3: null,
                            faq: 'https://www.infomaniak.com/fr/support/faq/admin2/kdrive',
                            hosting: 'https://www.infomaniak.com/fr/kdrive',
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order/drive`,
                        },
                        icon: {
                            color: '#5c89f7',
                            filter: 'invert(46%) sepia(83%) saturate(759%) hue-rotate(197deg) brightness(98%) contrast(97%)',
                        },
                    },
                    52: {
                        id: 52,
                        name: 'ksuite',
                        label: 'kSuite',
                        url: {
                            default: `${window['webComponentsStore']?.productsRouting?.manager}/v3/ng/ksuite/all`,
                            admin3: null,
                            faq: null,
                            hosting: 'https://www.infomaniak.com/fr/ksuite',
                            shop: `${window['webComponentsStore']?.productsRouting?.shop}/order2/ksuite`,
                        },
                        icon: {
                            color: null,
                            filter: null,
                        },
                    },
                };
            }
        }, 100);
    }
    getProduct(id) {
        return this.storeLoad ? this.products[id] : this.getProduct(id);
    }
}
